import { render, staticRenderFns } from "./depositRecord.vue?vue&type=template&id=4bd8abba"
import script from "./depositRecord.vue?vue&type=script&lang=js"
export * from "./depositRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports